import { FaUtensils } from "react-icons/fa";
import GlobalBanner from "./GlobalBanner";
import { useLocation } from "react-router-dom";

const AboutUs = ({ des1, des2, des3, des4 }) => {
  const location = useLocation();

  const images = [
    {
      src: "/images/real/restaurant-interior.jpeg",
      alt: "Restaurant interior",
      className: "w-full",
      position: "text-left",
      delay: "",
    },
    {
      src: "/images/real/chef-cooking-roti.jpeg",
      alt: "Chef cooking traditional roti over a wood fire",
      className: "w-full  ",
      position: "text-left",
      delay: "delay-100",
    },
    {
      src: "/images/real/mocktails-presentation.jpeg",
      alt: "Mocktails presentation",
      className: "w-full",
      position: "text-right",
      delay: "delay-200",
    },
    {
      src: "/images/real/rooftop-dining.jpeg",
      alt: "Rooftop dining experience",
      className: "w-full",
      position: "text-right",
      delay: "delay-300",
    },
  ];

  return (
    <div>
      {location.pathname == "/about-us" && (
        <GlobalBanner
          title="About Us"
          subtitle="About US"
          bgImage="https://secondhomemds.com/wp-content/uploads/2024/11/WhatsApp-Image-2024-11-23-at-3.12.14-PM-scaled.jpeg"
        />
      )}
      <div id="about" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Image Grid */}
            <div className="lg:w-1/2">
              <div className="grid grid-cols-2 p-3 gap-4">
                {images.map((image, index) => (
                  <div
                    key={index}
                    className={`${image.position} w-[11rem] h-[8rem] sm:w-[17rem] sm:h-[13rem] `}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className={`${image.className} rounded-lg w-full h-full shadow-lg transition-transform duration-500 hover:scale-105 ${image.delay}`}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Content */}
            <div className="lg:w-1/2">
              <h5 className="text-lg font-medium text-primary font-serif mb-2">
                About Our Restaurant
              </h5>
              <h1 className="font-display text-4xl font-bold text-gray-800 mb-6">
                Welcome to{" "}
                <FaUtensils className="inline text-primary mx-2" /> Second
                Home
              </h1>

              <p className="text-gray-600 mb-2">{des1}</p>
              <p className="text-gray-600 mb-2">{des2}</p>
              <p className="text-gray-600 mb-2">{des3}</p>
              <p className="text-gray-600 mb-8">{des4}</p>

              {location.pathname == "/" && (
                <>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                    <div className="flex items-center border-l-4 border-primary pl-4 py-2">
                      {/* <span className="text-5xl font-bold text-primary mr-4">
                  5
                </span> */}
                      <div>
                        <p className="text-gray-500">Years of</p>
                        <h6 className="text-lg font-semibold uppercase">
                          EXPERIENCE
                        </h6>
                      </div>
                    </div>

                    <div className="flex items-center border-l-4 border-primary pl-4 py-2">
                      {/* <span className="text-5xl font-bold text-primary mr-4">
                  50
                </span> */}
                      <div>
                        <p className="text-gray-500">Popular</p>
                        <h6 className="text-lg font-semibold uppercase">
                          MASTER CHEFS
                        </h6>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
